const PRODUCT_FORM_SELECTOR = 'form[id^="product-form-"]';
const VARIANT_MAPPING_SELECTOR = "script[data-variant-selling-plans]";

function getVariantSellingPlanMap(form) {
  const mappingScript = form.querySelector(VARIANT_MAPPING_SELECTOR);
  if (!mappingScript) return null;

  try {
    const rows = JSON.parse(mappingScript.textContent || "[]");
    return new Map(
      rows.map((row) => [String(row.id), row.selling_plan_id ? String(row.selling_plan_id) : null])
    );
  } catch (error) {
    return null;
  }
}

function setSellingPlanInput(form, sellingPlanId) {
  const existingInput = form.querySelector('input[name="selling_plan"]');

  if (!sellingPlanId) {
    existingInput?.remove();
    return;
  }

  if (existingInput) {
    existingInput.value = sellingPlanId;
    return;
  }

  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "selling_plan";
  input.value = sellingPlanId;
  form.append(input);
}

function syncSellingPlanForForm(form, variantId) {
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches(PRODUCT_FORM_SELECTOR)) return;

  const map = getVariantSellingPlanMap(form);
  if (!map) return;

  const resolvedVariantId = variantId || form.querySelector('input[name="id"]')?.value;
  if (!resolvedVariantId) return;

  setSellingPlanInput(form, map.get(String(resolvedVariantId)) || null);
}

function initSellingPlanSync() {
  const formsWithSellingPlanMapping = Array.from(document.querySelectorAll(PRODUCT_FORM_SELECTOR)).filter((form) =>
    form.querySelector(VARIANT_MAPPING_SELECTOR)
  );

  if (formsWithSellingPlanMapping.length === 0) {
    return;
  }

  formsWithSellingPlanMapping.forEach((form) => {
    syncSellingPlanForForm(form);
  });

  document.addEventListener("variant:change", (event) => {
    const formId = event.detail?.formId;
    const variantId = event.detail?.variant?.id;
    if (!formId) return;

    const form = document.getElementById(formId);
    syncSellingPlanForForm(form, variantId ? String(variantId) : null);
  });

  document.addEventListener(
    "change",
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.name !== "id") return;

      const form = target.form;
      syncSellingPlanForForm(form, target.value);
    },
    true
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSellingPlanSync, { once: true });
} else {
  initSellingPlanSync();
}

// Nosto Cart Drawer Refresh Logic
document.addEventListener("cart-drawer:refreshed", function () {
  const drawer = document.querySelector("cart-drawer");
  const nostoEl = drawer?.querySelector(".nosto_element");

  if (!window.Nosto || typeof window.Nosto.reloadCart !== "function" || !nostoEl || nostoEl.innerHTML.trim() !== "") {
    return;
  }
  
  window.Nosto.reloadCart();
});
